import { querySelector } from '../functions/querySelectors';

const DRAGGING_CLASS = 'w-file-drop--dragging';
const DRAGGED_CLASS = 'w-file-drop--dragged';
const DRAGGED_TEXT_CLASS = 'w-file-drop__dropped-text';
const DRAGGED_IMG_CLASS = 'w-file-drop__dropped-img';
const DROP_REMOVE_CLASS = 'w-file-drop__dropped-remove';
const WRONG_TYPE_ATTR = 'data-wrong-type';
const MAX_SIZE_ATTR = 'data-max-size';
const WRONG_SIZE_ATTR = 'data-wrong-size';
const WRAPPER_CLASS = 'js-add-file';

let getInput = function(wrapper) {
  return querySelector('input', wrapper);
};

let getWrapper = function(element) {
  return element.closest(`.${WRAPPER_CLASS}`);
};

let getTextElement = function(wrapper) {
  return querySelector(`.${DRAGGED_TEXT_CLASS}`, wrapper);
};

let fileChange = function(event) {
  let file = event.target.files[0];

  if (isValidFile(file, this)) {
    fileDropped(getWrapper(this), file);
    readUrl(this);
  }
  else {
    event.preventDefault();
  }
};

let readUrl = function(input) {
  let wrapper = getWrapper(input);
  // eslint-disable-next-line no-undef
  var reader = new FileReader();

  reader.onload = function(e) {
    let img = querySelector(`.${DRAGGED_IMG_CLASS}`, wrapper);
    img.innerHTML = `<img src="${e.target.result}" alt="">`;
  };

  reader.readAsDataURL(input.files[0]);
};

let isValidFile = function(file, input) {
  if (!(file && file.type)) {
    return false;
  }

  if (input.getAttribute('accept').indexOf(file.type) === -1) {
    // eslint-disable-next-line no-undef
    alert(input.getAttribute(WRONG_TYPE_ATTR));
    return false;
  }

  if (!(file && file.size)) {
    return false;
  }

  if (parseInt(input.getAttribute(MAX_SIZE_ATTR), 10) < file.size) {
    // eslint-disable-next-line no-undef
    alert(input.getAttribute(WRONG_SIZE_ATTR));
    return false;
  }

  return true;
};

let fileDropped = function(wrapper, file) {
  let textElement = getTextElement(wrapper);

  wrapper.classList.add(DRAGGED_CLASS);
  textElement.textContent = file.name;
};

let fileDrop = function(event) {
  event.preventDefault();

  let file = event.dataTransfer.files[0];
  this.classList.remove(DRAGGING_CLASS);

  if (isValidFile(file, getInput(this))) {
    this.classList.add(DRAGGED_CLASS);
    fileDropped(this, file);
  }
};

let fileClick = function(event) {
  getInput(this).click();
};

let fileDragLeave = function() {
  this.classList.remove(DRAGGING_CLASS);
};

let fileDragOver = function(event) {
  event.preventDefault();
  this.classList.add(DRAGGING_CLASS);
};

let removeClick = function(event) {
  event.preventDefault();
  event.stopPropagation();

  let wrapper = getWrapper(this);
  let input = getInput(wrapper);

  wrapper.classList.remove(DRAGGING_CLASS);
  wrapper.classList.remove(DRAGGED_CLASS);
  input.value = '';
};

export default function(wrapper) {
  let fileInput = getInput(wrapper);
  let remover = querySelector(`.${DROP_REMOVE_CLASS}`, wrapper);

  wrapper.addEventListener('dragover', fileDragOver);
  wrapper.addEventListener('dragleave', fileDragLeave);
  wrapper.addEventListener('click', fileClick);
  wrapper.addEventListener('drop', fileDrop);
  fileInput.addEventListener('change', fileChange);
  remover.addEventListener('click', removeClick);
};
